<template>
  <b-modal
    ref="loyalty-notify-import-customer-phone-modal"
    hide-footer
    :title="titleExcel"
    id="loyalty-notify-import-customer-phone-modal"
    no-close-on-backdrop
    size="xl"
  >
    <div>
      <b-row>
        <b-col>
          <div class="form-group">
            <span>
              <b>Bước 1:</b> Vui lòng chuẩn bị dữ liệu mẫu từ file excel đúng
              format, hoặc có thể tải ở
              <a :href="urlExcel">đây</a>
            </span>
          </div>
        </b-col>
      </b-row>
      <span> <b>Bước 2:</b> Tiến hành Import </span>
      <b-row>
        <b-col>
          <UploadFileMulter
            v-on:send-file="getDataFromExcel"
            v-on:clear-file="clearFileExcel"
            :cmdUrl="'loyalty-notifies/transform-customer-phone-excel'"
          />
          <span v-if="fileName"
            >Tên file: <b>{{ fileName }}</b>
          </span>
        </b-col>
      </b-row>
      <!-- End input session -->
    </div>
    <div class="mt-10" v-show="importItemLength !== 0">
      <hr
        class="hr-text"
        data-content="Danh sách khách hàng"
        style="font-weight: 600"
      />
      <b-table
        class="myTable"
        caption-top
        responsive
        bordered
        hover
        :fields="customerFields"
        :items="importItems"
        id="customer-table"
        :per-page="perPage"
        :current-page="currentPage"
        :busy="isBusy"
      >
        <template #cell(index)="data">
          {{ (currentPage - 1) * perPage + (data.index + 1) }}
        </template>
        <template #cell(fullName)="data">
          {{ data.item.fullName }}
        </template>
        <template #cell(phoneNo)="data">
          {{ data.item.phoneNo }}
        </template>
        <template #cell(status)="data">
          <b-badge :variant="data.item.isValid ? 'success' : 'danger'">
            {{ data.item.isValid ? 'Thành công' : 'Thất bại' }}
          </b-badge>
        </template>
        <template #cell(errors)="data">
          <div>
            <ul
              class="mb-0 pl-3"
              style="font-size: 12px"
              v-if="!data.item.isValid"
            >
              <li
                v-for="(error, idx) in data.item.errors"
                :key="idx"
                class="text-danger"
              >
                {{ error }}
              </li>
            </ul>
            <ul class="mb-0 pl-3" style="font-size: 12px" v-else>
              <li class="text-success">Hợp lệ</li>
            </ul>
          </div>
        </template>
        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle ml-3"></b-spinner>
            <strong>Loading...</strong>
          </div>
        </template>
        <template v-slot:cell(actions)="row">
          <i
            class="flaticon2-rubbish-bin-delete-button text-danger"
            @click="
              showDeleteAlert(
                'Xoá khách hàng ?',
                `Xoá ${row.item.fullName || row.item.phoneNo} khỏi danh sách`,
                row.item,
                confirmDelete,
              )
            "
            role="button"
            style="cursor: pointer"
          >
          </i>
        </template>
      </b-table>
      <b-col class="row mt-3">
        <b>
          Tổng số:
          {{ importItemLength || 0 }}
        </b>
        <span class="ml-3">
          (Thành công:
          <span class="text-success font-weight-bold">{{ validCount }}</span
          >, Thất bại:
          <span class="text-danger font-weight-bold">{{ invalidCount }}</span
          >)
        </span>
      </b-col>
      <b-pagination
        class="custom-pagination"
        v-show="importItemLength > perPage"
        v-model="currentPage"
        :total-rows="importItemLength"
        :per-page="perPage"
        aria-controls="customer-table"
        align="right"
      ></b-pagination>
    </div>
    <b-button
      style="width: 80px"
      class="mt-6 mr-2"
      v-if="importItemLength && !isBusy && validCount > 0"
      variant="primary"
      size="sm"
      @click="onSaveCustomers"
    >
      <strong>Lưu</strong>
    </b-button>
    <b-button
      v-if="importItemLength && isBusy"
      style="width: 100px"
      class="mt-6 mr-2"
      variant="primary"
      size="sm"
      disabled
    >
      <b-spinner small></b-spinner>
      Đang lưu...
    </b-button>
    <b-button
      class="mt-6"
      style="width: 80px"
      variant="secondary"
      size="sm"
      @click="hideModalExcel"
    >
      <strong>Hủy</strong>
    </b-button>
  </b-modal>
</template>
<script>
import { BASE_URL } from '@/utils/constants';
import UploadFileMulter from '@/view/modules/upload/UploadFileMulter';
import { showDeleteAlert, showConfirmDialog } from '@/utils/sweet-alert2.js';
import { makeToastFaile } from '@/utils/common';

export default {
  name: 'ImportCustomerPhone',
  props: {
    notifyTargetValue: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      titleExcel: 'Nhập excel số điện thoại khách hàng',
      urlExcel: BASE_URL + 'templates/download?type=loyalty-phone',
      onLoadingList: false,
      currentPage: 1,
      file: null,
      importItems: [],
      isBusy: false,
      fileName: '',
      perPage: 10,
      customerFields: [
        {
          key: 'index',
          label: 'STT',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32', width: '5%' },
          tdClass: 'text-center',
        },
        {
          key: 'fullName',
          label: 'Tên khách hàng',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32', width: '25%' },
          tdClass: 'text-left',
        },
        {
          key: 'phoneNo',
          label: 'Số điện thoại',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32', width: '20%' },
          tdClass: 'text-left',
          thClass: 'text-center',
        },
        {
          key: 'status',
          label: 'Trạng thái',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32', width: '15%' },
          tdClass: 'text-center',
          thClass: 'text-center',
        },
        {
          key: 'errors',
          label: 'Chi tiết',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32', width: '30%' },
          tdClass: 'text-left',
          thClass: 'text-center',
        },
        { key: 'actions', label: '', tdClass: 'text-center', width: '5%' },
      ],
    };
  },
  components: {
    UploadFileMulter,
  },
  computed: {
    validItems() {
      return this.importItems.filter((item) => item.isValid);
    },
    validCount() {
      return this.validItems.length;
    },
    invalidCount() {
      return this.importItems.filter((item) => !item.isValid).length;
    },
    importItemLength() {
      return this.importItems.length;
    },
  },
  methods: {
    showDeleteAlert,
    showModal() {
      this.$refs['loyalty-notify-import-customer-phone-modal'].show();
    },
    confirmDelete(row) {
      this.importItems = this.importItems.filter(
        (item) => item.index !== row.index,
      );
    },
    hideModalExcel() {
      this.$refs['loyalty-notify-import-customer-phone-modal'].hide();
      this.clearFileExcel();
    },
    async onSaveCustomers() {
      if (this.isBusy) return;

      const validItems = this.importItems.filter((item) => item.isValid);
      if (!validItems.length) {
        makeToastFaile('Không có dữ liệu hợp lệ để lưu');
        return;
      }

      if (this.invalidCount > 0) {
        try {
          await showConfirmDialog(
            'Xác nhận lưu dữ liệu',
            `Có ${this.invalidCount} bản ghi không hợp lệ sẽ bị loại bỏ. Bạn có muốn tiếp tục?`,
          );
        } catch {
          return;
        }
      }

      if (!validItems.length) {
        makeToastFaile('Không có dữ liệu hợp lệ để lưu');
        return;
      }
      this.$emit('add-customers', validItems);
      this.hideModalExcel();
    },
    getDataFromExcel(data, fileName) {
      const { rows } = data || {};
      this.fileName = fileName;

      if (rows && Array.isArray(rows)) {
        const existingItems = new Set(
          this.notifyTargetValue.map((item) => item.phoneNo),
        );
        this.importItems = rows.map((item, index) => {
          const hasExistingItem = existingItems.has(item.phoneNo);
          if (hasExistingItem) {
            item.isValid = false;
            item.errors = [...item.errors, 'Dữ liệu trùng lặp!'];
          }
          return {
            ...item,
            id: item.customerId,
            index: index + 1,
          };
        });
      } else {
        this.importItems = [];
        makeToastFaile('Dữ liệu không hợp lệ');
      }
      this.onLoadingList = false;
    },
    clearFileExcel() {
      this.importItems = [];
      this.fileName = '';
      this.file = null;
      this.onLoadingList = false;
    },
  },
};
</script>

<style lang="scss">
.loyalty-notify-import-customer-phone-modal {
  table.b-table[aria-busy='true'] {
    opacity: 0.6;
  }

  .modal-dialog.modal-xl {
    max-width: 95vw;
  }
}

#b-toaster-top-right {
  user-select: text;
  z-index: 999999999;
}
</style>
